<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="top-back">
            <div class="code">{{code}}</div>
            <div class="top-text" @click="copyId">我的邀请码&nbsp;&nbsp;<van-icon class="icon" name="/ayz_icon/copy.png"/></div>
        </div>

        <div class="main">
            <div class="main-top">
                <div class="main-top-num">{{today_bind_count}}</div>
                <div class="main-top-text">今日邀请</div>
            </div>
            <div class="main-top" @click="goInvite">
                <div class="main-top-num">{{sum_bind_count}}</div>
                <div class="main-top-text">全部邀请</div>
            </div>
            <div class="main-top" @click="goTotal">
                <div class="main-top-num">{{sum_revenue}}</div>
                <div class="main-top-text">全部收益</div>
            </div>
        </div>

        <div class="main">
            <div>
                <div class="main-cat">
                    一级推广邀请码:
                    <div class="main-pass" v-if="referral_level === 1">已开通 <van-icon size="12" name="passed" /></div>
                    <div class="main-pass" v-else>已失效 <van-icon size="12" name="close" /></div>
                </div>
                <div class="main-cat-option">
                    <div class="option-list">
                        <div class="option-list-text">
                            <i class="li-dot" /> &nbsp;&nbsp;
                            受邀用户获得7天VIP
                        </div>
                        <div class="option-list-text">
                            <i class="li-dot" /> &nbsp;&nbsp;
                            受邀用户消费分成比例20%
                        </div>
                        <div class="option-list-text">
                            <i class="li-dot" /> &nbsp;&nbsp;
                            下一层受邀用户消费分成比例5%
                        </div>
                    </div>
                </div>
            </div>

            <div  style="margin-top: 30px">
                <div class="main-cat">
                    二级推广邀请码:
                    <div class="main-pass" v-if="referral_level === 1" @click="upgrade">999元开通</div>
                    <div class="main-pass" v-if="referral_level === 2">已开通 <van-icon size="12" name="passed" /></div>
                    <div class="main-pass" v-if="referral_level === 3">已失效 <van-icon size="12" name="close" /></div>
                </div>
                <div class="main-cat-option">
                    <div class="option-list">
                        <div class="option-list-text">
                            <i class="li-dot" /> &nbsp;&nbsp;
                            受邀用户获得7天VIP+1张交换卡
                        </div>
                        <div class="option-list-text">
                            <i class="li-dot" /> &nbsp;&nbsp;
                            受邀用户消费分成比例40%
                        </div>
                        <div class="option-list-text">
                            <i class="li-dot" /> &nbsp;&nbsp;
                            下一层受邀用户消费分成比例10%
                        </div>
                    </div>
                </div>
            </div>


            <div  style="margin-top: 30px">
                <div class="main-cat">
                    门店和机构邀请码:
                    <div class="main-pass" v-if="referral_level !== 3" @click="upStation">申请开通</div>
                    <div class="main-pass" v-else>已开通 <van-icon size="12" name="passed" /></div>
                </div>
                <div class="main-cat-option">
                    <div class="option-list">
                        <div class="option-list-text">
                            <i class="li-dot" /> &nbsp;&nbsp;
                            受邀用户获得10天VIP+1张交换卡
                        </div>
                        <div class="option-list-text">
                            <i class="li-dot" /> &nbsp;&nbsp;
                            受邀用户消费分成比例60%
                        </div>
                        <div class="option-list-text">
                            <i class="li-dot" /> &nbsp;&nbsp;
                            下一层受邀用户消费分成比例10%
                        </div>
                    </div>
                </div>
            </div>

            <div class="btn-container" @click="goRecommend">
                <van-icon name="play-circle" /> &nbsp;兼职红娘邀请码系统介绍
            </div>
            <div style="margin-top: 10px;height: 1px"></div>
        </div>
        <ReferralFooter index="1"/>
    </div>
</template>

<script>

import {showFailToast, showSuccessToast} from "vant";
import ayzAjax from "@/plugins/axios";
import ReferralFooter  from "@/components/referralFooter.vue";
import {isAndroid, isIOS, isWebView, isWeiXin} from "@/assets/js/common";


export default {
    name: "ReloadView",
    components: {
        ReferralFooter
    },
    data: function () {
        return {
            userId:0,
            token:'',
            code:'0000',
            jwtInfo:null,
            userInfo:null,
            referral_level:1,
            today_bind_count:0,
            sum_revenue:0,
            sum_bind_count:0,
        }
    },
    created() {
        this.jwtInfo = JSON.parse(localStorage.getItem('jwtInfo'));
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (this.$route.query.id){
            if (parseInt(this.userId) !== parseInt(this.$route.query.id)){
                this.jwtInfo = null;
            }
            this.userId = this.$route.query.id;
            this.token = this.$route.query.token;
        }
        if (this.jwtInfo === null){
            this.onLogin();
        }else{
            if (this.userInfo === null){
                this.getInfo();
            }else{
                this.setValue();
            }
        }
        if(this.userInfo !== null){
            this.userId = this.userInfo.id;
        }
        window.refreshPage = this.refreshPage;//将refreshPage方法暴露给window,使安卓可以调用refreshPage方法
    },
    methods: {
        refreshPage(){
            window.location.reload();
        },
        upgrade(){
            if (isWeiXin()){
                return showFailToast('请前往APP开通');
            }
            let param = {};
            param.eventType = 4;//升级邀请码
            param = JSON.stringify(param)
            try {
                if (isAndroid() && isWebView()){
                    window.Android.ayz_interactive(param);
                }
                if(isIOS() && isWebView()){
                    window.webkit.messageHandlers.ayz_interactive.postMessage(param);
                }
            }catch(error){
                console.log(error);
                return showFailToast('敬请期待');
            }
        },

        upStation(){
            this.$router.push({ path: '/referral/audit'});
        },
        onLogin(){
            if (this.userId > 0 && this.token !== ''){
                let fromData = {};
                fromData.user_id = this.userId;
                fromData.user_token = this.token;
                try {
                    console.log(fromData)
                    ayzAjax.post('/referral/app_login',fromData).then((response) => {
                        if (response.data.code === 4){
                            return this.$router.push({ path: '/referral/login'});
                        }
                        if(response.data.code !== 200){
                            localStorage.setItem('jwtInfo', null);
                            return showFailToast(response.data.msg);
                        }
                        // if (response.data.code === 4){
                        //     this.$router.push({ path: '/referral/login'});
                        // }
                        this.jwtInfo = response.data.data.jwt_info;
                        // alert(JSON.parse(this.jwtInfo))
                        localStorage.setItem('jwtInfo', JSON.stringify(this.jwtInfo));
                        this.getInfo();
                    })
                }catch(error){
                    console.log(error);
                    // alert(JSON.parse(error))
                    return this.$router.push({ path: '/referral/login'});
                    // return showFailToast('网络错误,请稍后再试!');
                }
            }else{
                this.$router.push({ path: '/referral/login'});
            }
        },
        getInfo(){
            try {
                ayzAjax.get('/referral/my',{
                    headers: {
                        'Authorization': 'Bearer ' + this.jwtInfo.access_token,
                    }
                }).then((info) => {
                    if(info.data.code !== 200){
                        localStorage.setItem('jwtInfo', null);
                        return showFailToast(info.data.msg)
                    }
                    this.userInfo = info.data.data.user_info;
                    // alert(JSON.parse(this.jwtInfo))
                    // console.log(this.userInfo);
                    localStorage.setItem('userInfo', JSON.stringify(this.userInfo));

                    this.setValue();
                })
            }catch (error) {
                console.log(error);
                return showFailToast('网络错误,请稍后再试!');
            }

        },
        setValue(){
            this.userId = this.userInfo.id;
            this.token = this.userInfo.access_token;
            this.code = this.userInfo.referral_code;
            this.referral_level = parseInt(this.userInfo.referral_level);
            this.sum_bind_count = this.userInfo.sum_bind_count;
            this.sum_revenue = this.userInfo.sum_revenue;
            this.today_bind_count = this.userInfo.today_bind_count;
            localStorage.setItem('userId',this.userId);
            localStorage.setItem('userToken',this.token);
            // console.log(this.referral_level);
        },
        goInvite() {
            this.$router.push({ path: '/referral/invite'});
        },
        goTotal() {
            this.$router.push({ path: '/referral/total'});
        },
        goRecommend(){
            // console.log('兼职红娘邀请码系统介绍');
            this.$router.push({ path: '/common/video'});
        },
        copyId() {
            const text = this.code;
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            showSuccessToast('邀请码已复制');
        },
    }
}
</script>

<style lang="scss" scoped>

.reload-view{
    //width: 100%;
    background-color: #F6F6F6;
    text-align: left;
    .top-back{
        background-image: url('~@/assets/referral-back1.png');
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 120px;
        color: #FFFFFF;
        .code{
            padding-top: 30px;
            padding-left: 25px;
            font-weight: 600;
            font-size: 27px;
            color: #FC2E49;
        }
        .top-text{
            margin-top: 15px;
            margin-left: 25px;
            margin-right: 25px;
            font-weight: 300;
            font-size: 12px;
            color: #555555;
        }
    }

    .main{
        min-height: 100px;
        margin: 12px;
        background: #FFFFFF;
        border-radius: 17px 17px 17px 17px;
        text-align: center;
        .main-top{
            width: 33%;
            height: 80px;
            //background: #F94B54;
            float: left;
            text-align: center;
            .main-top-num{
                margin-top: 25px;
                font-weight: 500;
                font-size: 18px;
                color: #222222;
            }
            .main-top-text{
                margin-top: 15px;
                font-weight: 300;
                font-size: 11px;
                color: #161616;
            }
        }
        .main-cat{
            //width: px;
            padding-top: 30px;
            padding-left: 15px;
            padding-right: 25px;
            //font-weight: 500;
            font-size: 13px;
            color: #161616;
            text-align: left;
            line-height: 25px;
            font-weight: bold;
            .main-pass{
                float: right;
                width: 66px;
                height: 25px;
                line-height: 25px;
                border: #FC2E49 1px solid;
                border-radius: 5px;
                display: inline-block;
                font-weight: 500;
                font-size: 11px;
                color: #FC2E49;
                text-align: center;
            }
            .main-num{
                float: right;
                width: 90px;
                height: 25px;
                line-height: 25px;
                //border: #FC2E49 1px solid;
                //border-radius: 5px;
                display: inline-block;
                font-weight: 500;
                font-size: 11px;
                //color: #FC2E49;
                text-align: center;
            }
        }
        .main-cat-option{
            margin-top: 15px;
            height: 50px;
            //background: #F9F9F9;
            border-radius: 10px 10px 10px 10px;
            .option-list{
                text-align: left;
                .option-list-text{
                    margin-left: 20px;
                    margin-top: 10px;
                    font-weight: 400;
                    font-size: 12px;
                    color: #161616;
                    .li-dot{
                        float: left;
                        margin-top: 5px;
                        width: 5px;
                        height: 5px;
                        border-radius: 50%;
                        background: #222222;
                    }
                }

            }
        }

        .btn-container{
            margin: 80px auto;
            //margin-top: 80px;
            width: 300px;
            text-align: center;
            line-height: 50px;
            height: 50px;
            background: #FE405F;
            border-radius: 10px 10px 10px 10px;
            font-weight: 500;
            font-size: 13px;
            color: #FFFFFF;
        }
    }

    .icon{
        margin-top: 2px;
    }


}
.main-input{
    background: #F9F9F9;
}
.account-close{
    float: left;
    margin-left: 15px;
    margin-top: 15px;
    font-size: 14px;
    color: #969799;
}
.account-yes{
    float: right;
    margin-right: 15px;
    margin-top: 15px;
    font-size: 14px;
    color: #1989FA;
}
.account-edit{
    height: 150px;
    width: 100%;
    margin-top: 100px;
    //padding: 15px;
    .main-input{
        width: 90%;
        margin:0 auto;
    }
}
</style>
